import type { Service } from "@/types/content";

export const services: Service[] = [
  {
    id: "botox",
    name: "Botox",
    category: "Inyectables",
    image: "/images/services/botox.jpg",
    coverImage: "/images/services/botox-portada-v1.jpg",
    price: 4300,
    duration: "45 min",
    description:
      "Aplicacion de toxina botulinica para suavizar lineas de expresion y lograr un rostro mas descansado, fresco y natural.",
    benefits: [
      "Suaviza lineas de expresion",
      "Ayuda a prevenir marcas profundas",
      "Resultado natural y progresivo",
    ],
  },
  {
    id: "full-botox",
    name: "Full Botox",
    category: "Inyectables",
    image: "/images/services/full-botox.jpg",
    coverImage: "/images/services/full-botox-portada-v1.jpg",
    priceLabel: "Consultar",
    duration: "60 min",
    description:
      "Protocolo completo de toxina botulinica para tratar varias zonas del rostro segun diagnostico y objetivo estetico.",
    benefits: [
      "Atencion integral de varias zonas",
      "Mejora la armonia facial",
      "Plan personalizado segun valoracion",
    ],
  },
  {
    id: "hilos-tensores",
    name: "Hilos Tensores",
    category: "Reafirmacion",
    image: "/images/services/hilos-tensores.jpg",
    coverImage: "/images/services/hilos-tensores-portada-v1.jpg",
    priceLabel: "Consultar",
    duration: "90 min",
    description:
      "Tratamiento de soporte facial que ayuda a redefinir contornos y estimular firmeza con una tecnica minimamente invasiva.",
    benefits: [
      "Mejora la firmeza facial",
      "Ayuda a redefinir el contorno",
      "Estimula la produccion de colageno",
    ],
  },
  {
    id: "relleno-de-labios",
    name: "Relleno de Labios",
    category: "Labios",
    image: "/images/services/relleno-de-labios.jpg",
    coverImage: "/images/services/relleno-de-labios-portada-v1.jpg",
    price: 4600,
    duration: "60 min",
    description:
      "Perfilado y volumen labial con acido hialuronico, buscando proporcion, hidratacion y un acabado elegante.",
    benefits: [
      "Aporta volumen controlado",
      "Define el contorno labial",
      "Mejora hidratacion y simetria",
    ],
  },
  {
    id: "russian-lips",
    name: "Russian Lips",
    category: "Labios",
    image: "/images/services/russian-lips.jpg",
    coverImage: "/images/services/russian-lips-portada-v1.jpg",
    price: 4700,
    duration: "75 min",
    description:
      "Tecnica de labios con enfoque en elevacion, definicion del arco y volumen estilizado sin perder naturalidad.",
    benefits: [
      "Realza la forma del labio",
      "Favorece un efecto elevado",
      "Resultado definido y estetico",
    ],
  },
  {
    id: "rinomodelacion",
    name: "Rinomodelacion",
    category: "Perfilamiento",
    image: "/images/services/rinomodelacion-procedimiento-v2.jpg",
    coverImage: "/images/services/rinomodelacion-portada-v1.jpg",
    coverImageFit: "contain",
    coverImageCaption: "Vista de perfil",
    price: 6500,
    duration: "60 min",
    description:
      "Armonizacion nasal no quirurgica con relleno, enfocada en mejorar el perfil y equilibrar proporciones faciales.",
    benefits: [
      "Mejora el perfil nasal",
      "Procedimiento no quirurgico",
      "Resultado inmediato segun valoracion",
    ],
  },
  {
    id: "pdrn-infiltrado",
    name: "PDRN Infiltrado",
    category: "Regeneracion",
    image: "/images/services/pdrn-infiltrado.jpg",
    coverImage: "/images/services/pdrn-infiltrado-portada-v1.jpg",
    priceLabel: "Consultar",
    duration: "60 min",
    description:
      "Tratamiento regenerativo con PDRN para mejorar calidad de piel, luminosidad, hidratacion y recuperacion cutanea.",
    benefits: [
      "Estimula reparacion cutanea",
      "Mejora textura y luminosidad",
      "Favorece piel mas hidratada",
    ],
  },
  {
    id: "carboxiterapia",
    name: "Carboxiterapia · 2 áreas / 8 sesiones",
    category: "Corporal",
    image: "/images/services/carboxiterapia.jpg",
    coverImage: "/images/services/carboxiterapia-portada-v1.jpg",
    coverImageCaption: "Vista del abdomen",
    price: 5000,
    duration: "45 min",
    description:
      "Tecnica corporal y estetica que apoya la oxigenacion de tejidos y el tratamiento de zonas con celulitis o flacidez.",
    benefits: [
      "Apoya la microcirculacion",
      "Ayuda en celulitis y flacidez",
      "Complementa protocolos corporales",
    ],
  },
  {
    id: "limpieza-facial-profunda",
    name: "Limpieza Facial Profunda",
    category: "Facial",
    image: "/images/services/limpieza-facial-profunda.jpg",
    price: 550,
    duration: "60 min",
    description:
      "Higiene facial profunda con extraccion, exfoliacion y mascarilla calmante para dejar la piel limpia y luminosa.",
    benefits: [
      "Elimina impurezas y puntos negros",
      "Mejora textura y frescura",
      "Prepara la piel para otros tratamientos",
    ],
  },
  {
    id: "limpieza-facial-microdermoabrasion",
    name: "Limpieza Facial con Microdermoabrasion",
    category: "Facial",
    image: "/images/services/limpieza-facial-microdermoabrasion.jpg",
    price: 700,
    duration: "75 min",
    description:
      "Limpieza facial con microdermoabrasion para renovar la superficie de la piel y mejorar suavidad, brillo y textura.",
    benefits: [
      "Exfoliacion mas profunda",
      "Ayuda a suavizar textura",
      "Piel mas luminosa y uniforme",
    ],
  },
  {
    id: "masaje-anticelulitis",
    name: "Masaje Anticelulitis",
    category: "Corporal",
    image: "/images/services/masaje-anticelulitis-procedimiento-v2.jpg",
    coverImage: "/images/services/masaje-anticelulitis-portada-v1.jpg",
    coverImageCaption: "Vista de las piernas",
    priceLabel: "Consultar",
    duration: "60 min",
    description:
      "Masaje corporal enfocado en zonas con celulitis, retencion y textura irregular, ideal como parte de un plan corporal.",
    benefits: [
      "Apoya drenaje y circulacion",
      "Mejora sensacion de ligereza",
      "Complementa tratamientos corporales",
    ],
  },
  {
    id: "masaje-reductivo",
    name: "Masaje Reductivo · 8 sesiones (3 zonas)",
    category: "Corporal",
    image: "/images/services/masaje-reductivo.jpg",
    price: 4100,
    duration: "60 min",
    description:
      "Masaje de tecnica intensa para apoyar moldeado corporal, drenaje y reduccion de medidas dentro de un protocolo personalizado.",
    benefits: [
      "Ayuda al moldeado corporal",
      "Favorece drenaje de liquidos",
      "Ideal para planes de seguimiento",
    ],
  },
  {
    id: "masaje-posoperatorio-facial",
    name: "Masaje Posoperatorio Facial",
    category: "Postoperatorio",
    image: "/images/services/masaje-posoperatorio-facial.jpg",
    priceLabel: "Consultar",
    duration: "60 min",
    description:
      "Masaje facial de apoyo postoperatorio orientado a drenaje, desinflamacion y recuperacion guiada segun indicacion.",
    benefits: [
      "Apoya el drenaje facial",
      "Ayuda a reducir inflamacion",
      "Acompana procesos de recuperacion",
    ],
  },
];
